export default "__VITE_ASSET__CcfEz8yw__"